import { defineMessages } from 'react-intl';

export default defineMessages({
  title: 'Search Results',
  homeCrumbTitle: 'Message Boards'
});
